import { GoalLandingPageModel } from '@models/goals';

// Identifiers for the optional landing-page sections whose visibility the creator
// can toggle from the editor. Each id is also the key of the matching section object
// on the landing page; the visibility flag lives on that section itself (`hidden`).
export const LandingPageSection = {
  PREVIEW_VIDEO: 'previewVideo',
  KEYWORDS: 'keywords'
} as const;

export type LandingPageSectionId = (typeof LandingPageSection)[keyof typeof LandingPageSection];

// A section is hidden when its own `hidden` flag is set. Pass the section object
// (e.g. landingPage.previewVideo); absent/undefined sections are treated as visible.
export function isSectionHidden(section: { hidden?: boolean | null } | null | undefined): boolean {
  return !!section?.hidden;
}

// Returns a copy of the landing page with the given section's `hidden` flag flipped.
// Keeps the section minimally valid — previewVideo always carries a `url` string.
export function toggleSectionHidden(
  landingPage: GoalLandingPageModel,
  section: LandingPageSectionId
): GoalLandingPageModel {
  if (section === LandingPageSection.PREVIEW_VIDEO) {
    const current = landingPage.previewVideo ?? { url: '' };
    return { ...landingPage, previewVideo: { ...current, hidden: !current.hidden } };
  }
  const current = landingPage.keywords ?? {};
  return { ...landingPage, keywords: { ...current, hidden: !current.hidden } };
}
